import { PortfolioModel } from '../shared/models/portfolio-model';
import { PortfolioAccountManagerAdminModel } from '../shared/models/portfolio-account-manager-admin-model';
import { NodeStyleEventEmitter } from 'rxjs/internal/observable/fromEvent';
import { PortfolioService } from '../shared/services/portfolio.service';
import { CustomMessageService } from '../../core/message.service';
import { LookupService } from '../../shared/services/lookup.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'hr-portfolio-edit-account-manager',
  templateUrl: './portfolio-edit-account-manager.component.html',
  styleUrls: ['./portfolio-edit-account-manager.component.less'],
  standalone: false,
})
export class PortfolioEditAccountManagerComponent implements OnInit {
  constructor(
    private lookupService: LookupService,
    private portfolioService: PortfolioService
  ) {
    this.accountManagers = [];
  }

  @Output()
  public onEdit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  public onClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  public onUpdate: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  public isInEditMode: boolean = false;

  public selectedAccountManagerId: number;
  public accountManagers: PortfolioAccountManagerAdminModel[];

  @Input()
  public portfolio: PortfolioModel;

  public onEditAccountManagerClick() {
    this.loadDropDown();
    this.isInEditMode = true;
  }

  public onUpdateAccountManagerClick() {
    let portfolio = this.portfolio;
    this.portfolioService
      .savePortfolioAccountManager(
        this.selectedAccountManagerId,
        this.portfolio
      )
      .subscribe(() => {
        this.isInEditMode = false;
        this.onUpdate.emit(portfolio);
      });
    this.onCancelClick();
  }

  public onCancelClick() {
    this.isInEditMode = false;
  }

  public loadDropDown() {
    this.accountManagers = null;
    this.portfolioService.accountManagerList().subscribe((a) => {
      this.accountManagers = a.items;
    });
    this.selectedAccountManagerId =
      this.portfolio.currentAccountManager.admin.adminId;
  }

  ngOnInit() {}
}
